__turbopack_context__.v({
  "fade-in": "SearchLinkCloud-module-scss-module__WR7HSq__fade-in",
  "no-transform": "SearchLinkCloud-module-scss-module__WR7HSq__no-transform",
  "rotate": "SearchLinkCloud-module-scss-module__WR7HSq__rotate",
  "section": "SearchLinkCloud-module-scss-module__WR7HSq__section",
});
